import { initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config';

export default function () {
  const firebaseConfig = {
    apiKey: 'AIzaSyDjsHJNUxIFPplOKWdvVT60sZwBBZmIiko',
    authDomain: 'ed-web-75421.firebaseapp.com',
    projectId: 'ed-web-75421',
    storageBucket: 'ed-web-75421.appspot.com',
    messagingSenderId: '205937023718',
    appId: '1:205937023718:web:c2cd8f62e4e2620e86b927',
  };

  const app = initializeApp(firebaseConfig);
  const remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 15000;

  remoteConfig.defaultConfig = {
    subscrUK: 'subscrUK_a',
    subscrEU: 'subscrEU_a',
    pdf_upsale: 'upsale_on',
    customV2_pdf_19_29: 'customV2_pdf_19_29_a',
    currencyInISO: 'currencyInISO_a',
    ppPDFV2: 'ppPDFV2_a',
    p10_intro_pricesInDays: 'p10_intro_pricesInDays_a',
    p14_intro_pricesInDays: 'p14_intro_pricesInDays_a',
    p13_intro_pricesInDays: 'p13_intro_pricesInDays_a',
    p10_paymentPage_wt: 'p10_paymentPage_wt_off',
    p13_paywall_2blocks: false,
    p13_highPrices: false,
    p13v1_paywall_beforeAfter: false,
    p13v1_emailScreen: false,
    p13v33_emailScreen: false,
    p10_subscrUS: false,
    p13_newPrices_p17_p18: false,
    p13_US_newPrices_p17_p18: false,
    p13v1_paywall_moneyBack: false,
    // p13_mix_paywall_moneyBack: false,
    p13_mix_paywall_discountPercent: false,
    receive_email: 'false',
    p20v1_applePay_v3_mainMethod: false,
    p20v1_paywall_lastDogTraining: 'false',
    hardware: 'false',
    p20v1_paywall_redLabelDiscount_noSpecial: 'false',
  };

  function checkRemoteConfigValue(params) {
    window.firebaseConfigData = params;
    console.log(window.firebaseConfigData);
  }

  fetchAndActivate(remoteConfig)
    .then(() => {
      /* eslint no-underscore-dangle: ['error', { 'allow': ['_storageCache'] }] */
      if (remoteConfig._storageCache.activeConfig) {
        checkRemoteConfigValue(remoteConfig._storageCache.activeConfig);
      } else {
        checkRemoteConfigValue(remoteConfig.defaultConfig);
      }
    })
    .catch((err) => {
      console.log(err);
      checkRemoteConfigValue(remoteConfig.defaultConfig);
    });
  
  console.log('firebaseConfig enabled');
}
